/* eslint-disable no-undef */
import '../helpers/asset_host';
import { trackError } from 'helpers/track_error';

const track = event => {
  GustoAnalytics.track({
    eventCategory: 'ScheduleACall',
    eventName: event,
    data: {
      location: 'EMAIL_VERIFY',
    },
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const scheduleACallLink = document.getElementById('lead-nav-schedule_a_call');

  scheduleACallLink?.addEventListener('click', () => {
    const userInfoJSON = sessionStorage.getItem('CompanyLeadFields');
    if (userInfoJSON && ChiliPiper) {
      const userInfo = JSON.parse(userInfoJSON);
      const numberOfEmployees = parseInt(window.numberOfEmployeesForScheduleACall, 10) || 0;

      track('ModalShown');
      ChiliPiper.submit('gusto', 'talktogusto', {
        formId: numberOfEmployees > 25 ? 'mdr' : 'sbiz',
        map: true,
        debug: true,
        lead: {
          FirstName: userInfo.firstName,
          LastName: userInfo.lastName,
          Email: userInfo.email,
          Phone: userInfo.phone,
        },
        onSuccess: () => {
          track('SchedulingSuccess');
        },
        onError: () =>
          trackError({
            error: new Error(`Error submitting ChiliPiper call - ${window.location.pathname}`),
          }),
        onClose: () => track('SchedulingClosed'),
        onRouted: () => track('SchedulingRoutingStarted'),
      });
    }
  });
});
